export function termSortValue(term: string | null | undefined): number {
  const match = (term ?? "").trim().match(/^(\d{2})([WSXF])$/i);
  if (!match) {
    return 0;
  }

  const [, yearText, season] = match;
  const seasonWeight = { W: 1, S: 2, X: 3, F: 4 }[season.toUpperCase() as "W" | "S" | "X" | "F"];
  return Number(yearText) * 10 + seasonWeight;
}

export function compareTermsByMostRecent(left: string | null | undefined, right: string | null | undefined): number {
  return termSortValue(right) - termSortValue(left);
}
